angular.module('shbdeployer.docker').controller('ContainersController', ContainersController);

/* @ngInject */
function ContainersController($scope, ContainerService, Notifications, endpoint) {
  $scope.offlineMode = endpoint.Status !== 1;
  $scope.endpoint = endpoint;

  $scope.getContainers = getContainers;

  function getContainers() {
    ContainerService.containers(1)
      .then(function success(data) {
        $scope.containers = data;
      })
      .catch(function error(err) {
        Notifications.error('Ошибка', err, 'Не удалось получить список контейнеров');
        $scope.containers = [];
      });
  }

  function initView() {
    getContainers();
  }

  initView();
}
